export default "__VITE_ASSET__DgfKXa2F__"